// Remove the following lines, if you do not need any of Bootstrap's JavaScript features
import $ from "jquery";
import "popper.js";
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'slick-carousel';

window.jQuery = $;
window.$ = $;

require("bootstrap");

var currentMouseX = 0;
var currentMouseY = 0;
var scrollPos = 0;
var prevScrollPos = 0;
var bodyBtm = 0;
var windowBtm = 0;
var windowHeight = 0;
var scroll_functions = [];

$(window).ready(function($) {
	function GetIEVersion() {
	  var sAgent = window.navigator.userAgent;
	  var Idx = sAgent.indexOf("MSIE");
	  // If IE, return version number.
	  if (Idx > 0) 
		return parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
	  // If IE 11 then look for Updated user agent string.
	  else if (!!navigator.userAgent.match(/Trident\/7\./)) 
		return 11;
	  else
		return 0; //It is not IE
	}

	var ieVersion = GetIEVersion();
	if (ieVersion > 0) {
		$('body').addClass('is-ie');
		if (ieVersion <= 11) {
			$('body').addClass('is-outdated-ie');
			$('body').prepend('<div class="ie-msg p-3" style="background:black !important; position: fixed; bottom: 0; left: 0; width: 100%; text-align: center; z-index: 9999;"><p class="m-0" style="color:white !important;"><strong>Sorry, this site is not designed for your version of Internet Explorer. We suggest you <a style="text-decoration:underline; color:white;" href="https://www.zdnet.com/article/microsoft-security-chief-ie-is-not-a-browser-so-stop-using-it-as-your-default/">read an article from Microsoft’s security chief in February 2019 and update your browser.</a></strong></p></div>');
		}
	}
	function repositionParallaxPhotos() {
		var photos = $('.parallax-photo.active');
		$.each(photos, function() {
            var x = currentMouseX - $(this).offset().left + $(window).scrollLeft();
            var y = currentMouseY - $(this).offset().top + $(window).scrollTop();
            var rY = map(x, 0, $(this).width(), -17, 17);
            var rX = map(y, 0, $(this).height(), -17, 17);
            $(this).children(".background").css("transform", "translate3d(" + (rY/2*-1) + "px, " + (rX/2*-1) + "px, 0px)");
            $(this).children(".base").css("transform", "translate3d(" + rY + "px, " + rX + "px, 0px)");
            $(this).children(".overlay-2").css("transform", "translate3d(" + (rY-(rY/2)) + "px, " + (rX-(rX/2)) + "px, 0px)");
            $(this).children(".overlay-1").css("transform", "translate3d(" + (rY/2*-1) + "px, " + (rX/2*-1) + "px, 0px)");
        });
	}
	function activatePhotoListeners() {
        $('body').on('mousemove', function (e) {
			currentMouseX = e.clientX;
			currentMouseY = e.clientY;
            repositionParallaxPhotos();
        });
	}
	function deactivatePhotoListeners() {
		$('.parallax-photo').off('mousemove');
		$('.parallax-photo').off('mouseenter');
		$('.parallax-photo').off('mouseleave');
	}
	function map(x, in_min, in_max, out_min, out_max) {
		return (x - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
	}
	function assignPositionClasses(itm, active) {
		var classes = ['in', 'top-in-view', 'bottom-in-view', 'below', 'above'];
		for (var i = 0; i < classes.length; i++) {
			if (active === classes[i]) {
				$(itm).addClass(classes[i]);
			} else {
				$(itm).removeClass(classes[i]);
			}
		}
	}
	function checkActiveSection() {
		$.each($('.section-group'), function() {
			if (scrollPos > $(this).offset().top) {
				$(this).addClass('above').removeClass('below');
			} else if (scrollPos < $(this).offset().top) {
				$(this).addClass('below').removeClass('above');
			} else {
				$(this).removeClass('below').removeClass('above');
			}
		});
		if ($('.section-group.below').length <= 0) {
			$('#next-section').addClass('disabled');
		} else {
			$('#next-section').removeClass('disabled');
		}
		if ($('.section-group.above').length <= 0) {
			$('#prev-section').addClass('disabled');
			$('#top-page').addClass('disabled');
		} else {
			$('#prev-section').removeClass('disabled');
			$('#top-page').removeClass('disabled');
		}
	}
	function doFixedSections() {
		
		$.each($('.parallax-section'), function() {
			var objTop = $(this).offset().top;
			var objBottom = $(this).offset().top + $(this).outerHeight();
			var cls = 'above';
			if (scrollPos >= objTop && windowBtm < objBottom) {
				cls = 'in';
			} else if (windowBtm >= objTop && scrollPos < objTop) {
				cls = 'top-in-view';
			} else if (scrollPos >= objTop && scrollPos < objBottom) {
				cls = 'bottom-in-view';
			} else if (scrollPos > objBottom) {
				cls = 'below';
			}
			assignPositionClasses(this,cls);
		});
		
		$.each($('.divider-section'), function() {
			var objTop = $(this).offset().top;
			var objBottom = $(this).offset().top + $(this).outerHeight();
			var opacity = 1;
			if (windowBtm >= objTop && scrollPos < objBottom) {
				$(this).addClass('active');
			} else {
				$(this).removeClass('active');
			}
			//
			// adjust opacity of title slide
			var topOffset = .3; // percentage to start fade
			var bottomOffset = .7; // percentage to be fully faded
			var relPos = scrollPos - objTop;
			var height = objBottom - objTop;
			var opacity = 1;
			if (windowBtm < objTop + (height * topOffset)) {
				opacity = 1;
			} else if (scrollPos > objBottom) {
				opacity = 0;
			} else {
				var percentage = 1 - (relPos / ((objBottom - objTop) * bottomOffset));
				opacity = percentage;
			}
			//console.log('btm: ' + objBottom + ' top: ' + objTop + ' scroll: ' + scrollPos + ' opacity: ' + opacity);
			if (opacity > 1) opacity = 1;
			if (opacity < 0) opacity = 0;
			$(this).children('.title').css('opacity', opacity);
		});
	}
	
	function checkTopNav() {
		if (scrollPos > 0) {
			$("#default-nav p").addClass("hidden")
		} else {
			$("#default-nav p").removeClass("hidden")
		}
	}
	
    function handleScrollActions() {
        prevScrollPos = scrollPos;
        scrollPos = $(window).scrollTop();
        windowBtm = scrollPos + windowHeight;
        if (prevScrollPos > scrollPos) {
            $('body').addClass('scrolling-up').removeClass('scrolling-down');
        } else {
            $('body').addClass('scrolling-down').removeClass('scrolling-up');
        }
        for (var i = 0; i < scroll_functions.length; i++) {
            scroll_functions[i]();
        }
    }
    function setupScrollListeners() {
        scroll_functions.push(doFixedSections);
        scroll_functions.push(checkTopNav);
		scroll_functions.push(repositionParallaxPhotos);
		scroll_functions.push(checkActiveSection);
        $(window).scroll(function() {
            handleScrollActions();
        });
        $(window).resize(function() {
            scrollPos = $(window).scrollTop();
            windowHeight = $(window).height();
            bodyBtm = $('body').outerHeight();
            handleScrollActions();
        }).resize();
    }
	function scrollToRef(ref) {
		// rate of 2000px/s
		if (isNaN(ms)) ms = 2000;
		var distance = Math.abs(scrollPos - $(ref).offset().top);
		var ms = (distance / 9);
		var min = 500;
		var max = 2000;
		if (ms > max) ms = max;
		if (ms < min) ms = min;
		$('html, body').animate({
			scrollTop: $(ref).offset().top
		}, ms);
	}
	function activateSectionNav() {
		$('#top-page').click(function(e) {
			e.preventDefault();
			scrollToRef('body');
		});
		$('#prev-section').click(function(e) {
			if ($('.section-group.above').length > 0) {
				scrollToRef('#' + $('.section-group.above').last().attr('id'));
			}
		});
		$('#next-section').click(function(e) {
			if ($('.section-group.below').length > 0) {
				scrollToRef('#' + $('.section-group.below').first().attr('id'));
			}
		});
	}
	function activateYouTubeVideoAutoPlay() {
		// Autoplay YouTube video when the modal has been made visible to the user
		// Get the video src from the iframe
		var videoSrc = $("#CEOVideo").attr('src');
		// When the modal is opened, autoplay it
		$("#videoModal").on("show.bs.modal", function(e) {
		// Set the video src to autoplay
		$("#CEOVideo").attr("src", videoSrc + "?autoplay=1");
		// Pause the background video
		document.getElementById('intro-clip').pause();
		});
		// Stop playing the YouTube video once the modal is closed
		$("#videoModal").on("hide.bs.modal", function(e) {
		// Remove the video src from the iframe
		$("#CEOVideo").attr("src", '');
		// Resume the background video
		document.getElementById('intro-clip').play();
		});
	}
	
	// Hide default nav when fullscreen menu opens
	var defaultNav = document.getElementById("default-nav");
	var navToggleBtn = document.getElementsByClassName(".navbar-menu");

	$('#fullscreen-menu').on('show.bs.collapse', function () {
		defaultNav.classList.add("invisible");
	});
	$('#fullscreen-menu').on('hidden.bs.collapse', function () {
		defaultNav.classList.remove("invisible");
	});
	
	// Close fullscreen menu when a section link is clicked on
	$(function() {
		$(".menu-link").click(function(e) {
		  $('#fullscreen-menu').collapse('hide');
		});
	});
	
	// Toggle More/Less button text on expanded content
	var names = ["replacement", "investment", "awarded", "perspective", "funding", "cost", "efficient", "shortcomings", "understanding", "implications", "optimize", "projects", "completion", "technology", "needs", "customized", "holders", "personnel", "decade", "sources", "security", "health", "events", "outlets", "charities"];
	names.forEach(toggleMoreBtn);

	function toggleMoreBtn(item) {
		$('#more-content-' + item).on('hidden.bs.collapse', function () {
		  $("#more-btn-" + item).html('More<i class="fas fa-caret-down fa-lg"></i>');
		});
		$('#more-content-' + item).on('shown.bs.collapse', function () {
		  $("#more-btn-" + item).html('Less<i class="fas fa-caret-up fa-lg"></i>');
		});
	}
	
	// Toggle white background on Rider Rewards expanded content
	var riderRewards = document.getElementById("rider-rewards");
	
	$('#more-content-holders').on('hidden.bs.collapse', function () {
	  riderRewards.classList.remove("bg-white");
		riderRewards.classList.remove("text-dark");
	});
	$('#more-content-holders').on('show.bs.collapse', function () {
	  riderRewards.classList.add("bg-white");
		riderRewards.classList.add("text-dark");
	});
	
	// Check when each caption gets position sticky, dynamically adjust sticky class
	var sections = ["community", "system-redesign", "fare-equity", "rail-replacement", "infrastructure", "inside-rta", "conclusion"];
	sections.forEach(checkStickyCaptions);

	function checkStickyCaptions(item) {
		var observer = new IntersectionObserver(function(entries) {
		  // no intersection 
		  if (entries[0].intersectionRatio === 0)
			document.querySelector("#" + item + "-caption-box").classList.remove("sticky");
		  // fully intersects 
		  else if (entries[0].intersectionRatio === 1)
			document.querySelector("#" + item + "-caption-box").classList.add("sticky");
		}, {
		  threshold: [0, 1]
		});

		observer.observe(document.querySelector("#" + item + "-spacer"));
	}
	
	activateYouTubeVideoAutoPlay();
	activatePhotoListeners();
	activateSectionNav();
	setupScrollListeners();
});